<template>
  <div id="evaluationpublish" class="evaluationpublish" >
    <b-modal v-if="selectedEvaluation" id="modalPublish" title="Publish evaluation" @ok="publishEvaluation">
      <div class="form-group">
        <label>Publish date to student</label>
        <input class="form-control input-lg" type="datetime-local" v-model="selectedEvaluation.evaluationPublishDate"/>
      </div>
      <div class="form-group">
        <label class="control-label">Delay publishing to guardians</label>
        <b-form-select v-model="selectedEvaluation.publishDateGuardianDelay" class="mb-3">
          <option :value="null">Please select an option</option>
          <option value="0">simultaneous</option>
          <option value="12">12 hours</option>
          <option value="24">24 hours</option>
        </b-form-select>
      </div>
    </b-modal>
  </div>
</template>
<script>
import api from '../api'

export default {
  name: 'EvaluationPublish',
  props: ['selectedEvaluation'],
  methods: {
    publishEvaluation: function () {
      var studentPublishedDate = new Date(this.selectedEvaluation.evaluationPublishDate)
      var publishDateGuardian = new Date(studentPublishedDate)
      publishDateGuardian.setHours(publishDateGuardian.getHours() + this.selectedEvaluation.publishDateGuardianDelay)

      api.publishEvaluation(this.selectedEvaluation.id, studentPublishedDate, publishDateGuardian).then(response => {
        this.selectedEvaluation.publishedDate = response
        if (this.selectedEvaluation.lockedDate == null) {
          this.selectedEvaluation.lockedDate = new Date()
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/EvaluationPublish.vue